class SubscribeException extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}

export default function () {
    const service = {
        subscribe,
        publish
    };

    const subscribers = [];

    return service;

    function subscribe(eventName, callback) {
        if (callback === undefined || callback === null) {
            throw new SubscribeException('Callback needs to be defined');
        }

        subscribers.push({eventName, callback});
    }

    function publish(eventName) {
        const publishList = subscribers.filter(subsciber => subsciber.eventName === eventName);
        for (let i = 0; i < publishList.length; i++) {
            const subscriber = publishList[i];

            subscriber.callback.call({});
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/tagSwitchService.js